<template>
  <div id="harpsRates" class="flex items-center"
    v-if="colorfulHarps+halfColorHarps+grayHarps>0">
      <img v-for="(harp, index) in colorfulHarps"
        :key="index + Math.floor((Math.random() * 1000) + 1)"
        src="@/images/compact_disc_gold.svg" alt="harp"
         style="fill:#CE9B1C" :class="starsClass">
      <img v-if="halfColorHarps!==0"
        src="@/images/compact_disc_half_grey.svg" alt="harp"
        style="fill:#CE9B1C" :class="starsClass">
      <img v-for="(harp, index) in grayHarps"
        :key="index + Math.floor((Math.random() * 1000) + 1)"
        src="@/images/compact_disc_grey.svg" :class="starsClass"
        alt="harp" style="fill:#CE9B1C">
  </div>
</template>

<script>
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';

export default {
  props: ['starsAvg', 'starsClass'],

  data() {
    return {
      colorfulHarps: 0,
      halfColorHarps: 0,
      grayHarps: 0,
    };
  },

  mixins: [StreamFunctionsMixin],

  mounted() {
    this.setRate();
  },

  watch: {
    starsAvg() {
      this.setRate();
    },
  },

  methods: {
    setRate() {
      this.colorfulHarps = this.getTeacherRate(this.starsAvg).colorfulHarps;
      this.halfColorHarps = this.getTeacherRate(this.starsAvg).halfColorHarps;
      this.grayHarps = this.getTeacherRate(this.starsAvg).grayHarps;
    },
  },
};
</script>
